import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { api } from "../lib/api";
import { useT } from "../lib/i18n";
import { SectionTitle } from "../components/Reveal";

const slug = (s) => s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-");

export default function Genres() {
  const { t } = useT();
  const [genres, setGenres] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get("/genres").then((r) => setGenres(Array.isArray(r.data) ? r.data : [])).catch(() => {});
  }, []);

  return (
    <main data-testid="genres-page" className="max-w-[1500px] mx-auto px-4 lg:px-10 pt-32 pb-24">
      <SectionTitle index={t("menu.music")} kicker={t("genres.kicker")} title={<>{t("menu.genres")}<span className="text-[#1FD1FF]">.</span></>} />
      <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-t border-white/10">
        {genres.map((g, i) => (
          <motion.li key={g.name} initial={{ opacity: 0, y: 12 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }} transition={{ duration: 0.4, delay: (i % 6) * 0.04 }}>
            <Link to={`/generos/${encodeURIComponent(g.name)}`} data-testid={`genre-link-${slug(g.name)}`}
              className="group flex items-center justify-between gap-4 py-5 px-1 border-b border-white/10 hover:bg-white/[0.03] transition-colors">
              <span className="font-display text-3xl sm:text-4xl leading-none group-hover:text-[#1FD1FF] transition-colors">{g.name}</span>
              <span className="flex items-center gap-3 font-mono text-xs text-[#A8B3C4]">
                <span data-testid={`genre-count-${slug(g.name)}`}>{g.count} {t("genres.mixes")}</span>
                <ArrowUpRight className="w-4 h-4 group-hover:text-[#1FD1FF] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
              </span>
            </Link>
          </motion.li>
        ))}
      </ul>
    </main>
  );
}
